/* RESPONSIBLE TEAM: team-phone */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  attrs: {
    integration: { key: 'integration_id' },
  },
});
